import React from 'react';
import { Link } from 'react-router-dom';
import { usePermissions } from '@/app/permissions';

export const Nav: React.FC = () => {
  const perms = usePermissions();
  return (
    <nav style={{ display:'flex', gap: 12, fontSize: 14, margin: '8px 0' }}>
      <Link to="/dashboard/home">Home</Link>
      {perms['Punches'] && <Link to="/dashboard/timbrature">Timbrature</Link>}
      {perms['Shifts'] && <Link to="/dashboard/turni">Turni</Link>}
      {perms['Monthly bills'] && <Link to="/dashboard/conteggio-mensile">Mensile</Link>}
      {perms['Leave days'] && <Link to="/dashboard/vacanze">Vacanze</Link>}
      <Link to="/dashboard/policy">Policy</Link>
      <Link to="/dashboard/change-password">Password</Link>
    </nav>
  );
};
